import { useState } from 'react';
import ContextMenu from './ContextMenu';
import { getCollectionContextMenuOptions } from '../../utils/collectionContextMenu';
import { useTheme } from '../../hooks/useTheme';

export default function CollectionListItem({ collection, isSelected, isLocked, onClick, onAddFilter, onDeleteCollection, onUnselectCollection }) {
  const { currentThemeType, themeTypes } = useTheme();
  const [contextMenu, setContextMenu] = useState(null);

  const isLightTheme = currentThemeType === themeTypes.LIGHT;

  const handleContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setContextMenu({ x: e.clientX, y: e.clientY });
  };

  const contextMenuOptions = getCollectionContextMenuOptions({
    collection,
    onCopyTitle: (title) => {
      navigator.clipboard.writeText(title);
      setContextMenu(null);
    },
    onUnselectCollection: (collectionId) => {
      setContextMenu(null);
      onUnselectCollection?.(collectionId);
    },
    onAddFilter: (filter) => {
      setContextMenu(null);
      onAddFilter?.(filter);
    },
    onDeleteCollection: (collectionId) => {
      setContextMenu(null);
      onDeleteCollection?.(collectionId);
    },
  });

  return (
    <>
      <button
        onClick={onClick}
        onContextMenu={handleContextMenu}
        className="w-full p-3 bg-gray-800/50 hover:bg-gray-800 border border-gray-700 rounded-lg transition-all duration-200 text-left"
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1 min-w-0">
            {collection.title === "Generating title..." ? (
              <div className="flex items-center gap-2 mb-2">
                <div className="h-4 flex-1 bg-gray-700 rounded animate-pulse"></div>
                <svg className="animate-spin h-3 w-3 text-purple-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            ) : (
              <h3 className="text-white font-semibold text-sm mb-2 truncate">
                {collection.title || <span className="text-gray-400 italic">No title</span>}
              </h3>
            )}
            <div className="flex items-center gap-2 flex-wrap">
              <span className={`inline-block px-2 py-1 rounded text-xs font-semibold ${isLightTheme ? 'bg-blue-100 text-blue-700' : 'bg-blue-600/20 text-blue-400'}`}>
                {collection.product}
              </span>
              {collection.title === "Generating title..." ? (
                <span className={`inline-block px-2 py-1 rounded text-xs font-semibold w-16 h-5 animate-pulse ${isLightTheme ? 'bg-gray-200' : 'bg-gray-700'}`}></span>
              ) : (
                collection.category && (
                  <span className={`inline-block px-2 py-1 rounded text-xs font-semibold ${isLightTheme ? 'bg-purple-100 text-purple-700' : 'bg-purple-600/20 text-purple-400'}`} style={{ color: 'var(--color-text-on-accent)' }}>
                                      {collection.category}
                  </span>
                )
              )}
            </div>
          </div>

          {/* Selection Indicator - Lock icon, white circle, or none */}
          <div className="flex-shrink-0">
            {isLocked ? (
              <div className="relative">
                <svg className={`w-6 h-6 ${isLightTheme ? 'text-amber-600' : 'text-amber-400 drop-shadow-[0_0_8px_rgba(251,191,36,0.6)]'}`} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 1a5 5 0 00-5 5v4H6a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2h-1V6a5 5 0 00-5-5zm-3 5a3 3 0 116 0v4H9V6zm3 9a2 2 0 110-4 2 2 0 010 4z"/>
                </svg>
              </div>
            ) : isSelected ? (
              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-white to-gray-100 border-2 border-gray-300 shadow-lg"></div>
            ) : null}
          </div>
        </div>
      </button>

      {contextMenu && (
        <ContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          options={contextMenuOptions}
          onClose={() => setContextMenu(null)}
        />
      )}
    </>
  );
}
